// extracted by mini-css-extract-plugin
export default {"imageContainer":"B0-z","summaryPar":"C0-z","ratingCategories":"D0-z","reviewerInfo":"E0-z","reviewTypes":"F0-z","expanded":"G0-z"};